import * as React from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import PageBaseLayout from '../layouts/PageBaseLayout';
import { Outlet } from 'react-router';
import useBackdrop from '../hooks/useBackdrop';
import useSnackbar from '../hooks/useSnackbar';
import { supabase } from '../supabase-client';
import type { Transaction } from '../models/types';
import moment from 'moment';

export default function AffiliateTransactions() {
  const [selectedFilter, setSelectedFilter] = React.useState('all');
  const [transactions, setTransactions] = React.useState<Transaction[]>([]);
  const backdrop = useBackdrop();
  const snackbar = useSnackbar();

  const handleChangeFilter = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    setSelectedFilter(newAlignment);
  };

  const fetchData = async () => {
    backdrop.handleBackdropOpen();

    try {
      const { data, error } = await supabase
        .schema('app')
        .from('transactions')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching transactions:', error);
        throw error;
      }

      setTransactions(data);
    } catch (error) {
      const errorCast = error as Error;
      console.error(errorCast.stack);
      snackbar.handleSnackbarOpen(errorCast.message, 'error');
    }

    backdrop.handleBackdropClose();
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <PageBaseLayout
      title="Affiliate Transactions"
      //   actions={
      //     <Button
      //       component={Link}
      //       to="./new"
      //       startIcon={<GridAddIcon />}
      //       size="small"
      //       variant="contained">
      //       New Campaign
      //     </Button>
      //   }
    >
      {/* <Button
        onClick={async () => {
          const response = await supabase.functions.invoke(
            'vouchers/WEILONGVOUCHER2/redeem',
            { method: 'POST' },
          );
          console.log(response.data);
        }}
        startIcon={<GridAddIcon />}
        size="small"
        variant="contained">
        xdts
      </Button> */}
      <ToggleButtonGroup
        color="primary"
        value={selectedFilter}
        exclusive
        onChange={handleChangeFilter}
        aria-label="Platform">
        <ToggleButton value="all">All</ToggleButton>
        <ToggleButton value="earning">Earning</ToggleButton>
        <ToggleButton value="withdrawal">Withdrawal</ToggleButton>
      </ToggleButtonGroup>
      <div
        style={
          {
            //   maxHeight: 400,
            //   overflowY: 'auto',
          }
        }>
        <List
          sx={{
            width: '100%',
            // maxHeight: 500,
            bgcolor: 'background.paper',
          }}>
          {transactions
            .filter((transaction) => {
              if (selectedFilter === 'all') {
                return true;
              }
              return transaction.type === selectedFilter;
            })
            .map((transaction, i) => (
              <React.Fragment key={i}>
                {i !== 0 && <Divider component="li" />}
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={
                      <Typography variant="h4" fontWeight="bold">
                        ${transaction.amount}
                      </Typography>
                    }
                    secondary={
                      <>
                        <span>{transaction.user_id}</span>
                        <br />
                        <span>
                          {transaction.type} -{' '}
                          {moment(transaction.created_at).format(
                            'D MMM YYYY HH:mm',
                          )}
                        </span>
                      </>
                    }
                  />
                </ListItem>
              </React.Fragment>
            ))}
          <Divider component="li" />
          <ListItem alignItems="flex-start">
            <ListItemText
              primary="Brunch this weekend?"
              secondary={
                <>
                  <Typography
                    component="span"
                    variant="body2"
                    sx={{ color: 'text.primary', display: 'inline' }}>
                    Ali Connors
                  </Typography>
                  {" — I'll be in your neighborhood doing errands this…"}
                </>
              }
            />
          </ListItem>
          <Divider variant="inset" component="li" />
          <ListItem alignItems="flex-start">
            <ListItemText
              primary="Summer BBQ"
              secondary={
                <React.Fragment>
                  <Typography
                    component="span"
                    variant="body2"
                    sx={{ color: 'text.primary', display: 'inline' }}>
                    to Scott, Alex, Jennifer
                  </Typography>
                  {" — Wish I could come, but I'm out of town this…"}
                </React.Fragment>
              }
            />
          </ListItem>
          <Divider variant="inset" component="li" />
          <ListItem alignItems="flex-start">
            <ListItemText
              primary="Oui Oui"
              secondary={
                <React.Fragment>
                  <Typography
                    component="span"
                    variant="body2"
                    sx={{ color: 'text.primary', display: 'inline' }}>
                    Sandra Adams
                  </Typography>
                  {' — Do you have Paris recommendations? Have you ever…'}
                </React.Fragment>
              }
            />
          </ListItem>
        </List>
      </div>
      <Outlet />
    </PageBaseLayout>
  );
}
